export const setCookieData = (key, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  }
  const host = window.location.host;
  const domainPartsArray = host.split(".");
  if (domainPartsArray.length === 1) {
    document.cookie = key + "=" + value + expires + "; path=/";
  } else {
    let domain = domainPartsArray[domainPartsArray.length - 2] + "." + domainPartsArray[domainPartsArray.length - 1];
    document.cookie = key + "=" + value + expires + "; path=/; domain=" + domain;
  }
};
export const getCookieData = (key) => {
  const cookiePairs = document.cookie ? document.cookie.split(";") : [];
  for (const pair of cookiePairs) {
    const trimmed = pair.trim();
    if (!trimmed) {
      continue;
    }

    const separatorIndex = trimmed.indexOf("=");
    if (separatorIndex >= 0) {
      const cookieKey = trimmed.substring(0, separatorIndex).trim();
      if (cookieKey === key) {
        return trimmed.substring(separatorIndex + 1);
      }
    }
  }
  return null;
};
export const eraseCookieData = (key) => {
  console.log("erase cookie call");
  setCookieData(key, null, -1);
};
